<script lang="ts">
	import InputText from '$lib/elements/inputs/variants/InputText.svelte';
	import type { InputTextProps } from '$lib/elements/inputs/types';
	import { snackbar } from '$lib/stores';
	import { onMount } from 'svelte';
	import { t } from 'svelte-i18n';
	import ProgressIndicator from '$lib/elements/ProgressIndicator.svelte';

	export let numberOfCharacters: number = 0;
	export let inputPinCodeValue: string = '';
	export let codeFromURL: string = '';
	export let isFetching;

	let inputPinCode: InputTextProps[] = [];
	let inputPinCodeValueArray: string[] = [];

	onMount(async () => {
		if (numberOfCharacters) {
			for (const i of Array(numberOfCharacters)) {
				inputPinCode.push({
					placeholder: '*'
				});
				inputPinCode = inputPinCode;
			}
		}
		if (codeFromURL) {
			if (codeFromURL.length > numberOfCharacters) {
				snackbar.danger($t('privateOperationCodeURLParamError'));
			} else {
				let myPromise = () =>
					new Promise((resolve) => {
						setTimeout(function () {
							resolve('Count');
						}, 200);
					});

				for (const input of inputPinCode) {
					const i = inputPinCode.indexOf(input);
					await myPromise();
					input.value = codeFromURL.split('')[i];
					inputPinCode = inputPinCode;
				}

				rebuildInputPinCodeValueArray();
			}
		}
	});

	const rebuildInputPinCodeValueArray = () => {
		inputPinCodeValueArray = inputPinCode
			.map((i) => {
				return i.value;
			})
			.filter((v) => v !== undefined && v !== '');
	};

	$: if (inputPinCodeValueArray.length === numberOfCharacters) {
		inputPinCodeValue = inputPinCodeValueArray.join('');
	} else {
		inputPinCodeValue = '';
	}
</script>

{#if inputPinCode?.length}
	{#if isFetching}
		<div class="flex flex-col justify-center items-center h-[50px]">
			<ProgressIndicator />
		</div>
	{:else}
		<div class="flex gap-2">
			{#each inputPinCode as inputProps, i}
				<InputText
					props={inputProps}
					maxlength="1"
					on:keyup={(e) => {
						if (e.keyCode === 8) {
							!inputProps.value && inputPinCode[i - 1]?.ref.focus();
						} else {
							let nextInput = inputPinCode[i + 1];
							if (nextInput) {
								inputProps.value && nextInput.ref.focus();
								rebuildInputPinCodeValueArray();
							} else {
								rebuildInputPinCodeValueArray();
							}
						}
					}}
					on:paste={(e) => {
						e.preventDefault();
						let paste = (e.clipboardData || window.clipboardData).getData('text');
						if (paste.length === numberOfCharacters) {
							paste.split('').forEach((c, i) => {
								inputPinCode[i].value = c;
							});
							inputPinCode[inputPinCode.length - 1].ref.focus();
						} else {
							snackbar.danger($t('privateOperationCodePasteError'));
						}
					}}
				/>
			{/each}
		</div>
	{/if}
{/if}

<style lang="postcss">
	div {
		& :global(.input) {
			@apply !px-1 !text-center uppercase font-bold caret-transparent;
		}
	}
</style>
